import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { WmTransitionModule } from '../transition/index';
import { WmIconModule } from '../icon/index';

@NgModule({
	declarations: [TooltipComponent],
	imports: [CommonModule, WmTransitionModule, WmIconModule],
	exports: [TooltipComponent]
})
export class WmTooltipModule {}
